export default __webpack_public_path__ + "static/media/brasao_niteroi.8a7e3b9c.png";